import MvnoDashboard from "../../Components/MVNO/MvnoDashboards";

export default function MvnoDashboards(){
    return(
        <MvnoDashboard/>
    )
}